<script>
  import { onMount } from "svelte";
  import { slide } from "svelte/transition";
  import { ignore } from "../../Common/tools";
  import ImagePicker from "../../Common/ImagePicker.svelte";
  import Checkbox from "../../Common/Checkbox.svelte";
  import {External, M} from "../../external";

  export let field,
    settings = {},
    steps = [],
    onChange = ignore;

  let iconUi = null,
    tagUi = null;

  let pickIcon = () => {
    let ui = External.$(iconUi);
    let current = settings.tileIcon || "mi-star";
    External.Tools.pickIcon(ui, current, icon => {
      External.Tools.applyIcon(ui, current, icon);
      settings.tileIcon = icon;
      onChange();
    });
  };

  onMount(() => {
    settings.tags = settings.tags || [];

    External.UITools.pickTags(External.$(tagUi), settings.tags, () => {
      onChange();
    });
  });
</script>

<div class="popup-widget-wrapper">
  <div class="popup-input-wrapper">
    <h5>{M.OPTION_IMAGE}</h5>
    <span class="col20 f-left small-info-text mt-5">{M.OPTION_IMAGE_DESC}</span>

    <ImagePicker
      {onChange}
      bind:image={settings.image}
      bind:imageBase={settings.imageBase} />
  </div>
  <div class="popup-input-wrapper">
    <h5>{M.OPTION_INFO}</h5>
    <span class="col20 small-info-text mt-5 f-left">{M.OPTION_INFO_DESC}</span>

    <input
      type="text"
      class="required transition-all"
      on:blur={onChange}
      bind:value={settings.description} />
  </div>

  <Checkbox
    bind:data={settings.showAdditionalInfo}
    {onChange}
    label={M.SHOW_ADDITIONAL_INFO}
    description={M.ADDITIONAL_INFO_DESC} />
  {#if settings.showAdditionalInfo}
    <div
      class="popup-input-wrapper mt-15"
      transition:slide|local={{ duration: 200 }}>
      <h5>{M.ADDITIONAL_INFORMATION}</h5>

      <input
        type="text"
        class="required transition-all"
        on:blur={onChange}
        bind:value={settings.additionalInfo} />
    </div>
  {/if}

  {#if field.layout === 'icon'}
    <div class="popup-input-wrapper form-widget-admin">
      <div class="info">
        <h5>{M.OPTION_ICON}</h5>
        <span>{M.OPTION_ICON_DESC}</span>
      </div>
      <div class="prefixed-input" style="height: 59px">
        {#if !settings.tileIcon || settings.tileIcon.indexOf('mi-') === 0}
          <span
            class="material-symbols-outlined"
            bind:this={iconUi}
            on:click={pickIcon}>{(settings.tileIcon || 'mi-star').substring(3)}</span>
        {:else}
          <span
            class="fa {settings.tileIcon}"
            bind:this={iconUi}
            on:click={pickIcon} />
        {/if}
      </div>
    </div>
  {/if}
  <Checkbox
    bind:data={settings.skipToStep}
    {onChange}
    label={M.OPTION_SKIP}
    description={M.OPTION_SKIP_DESC} />
  {#if settings.skipToStep}
    <div
      class="popup-input-wrapper mt-15"
      transition:slide|local={{ duration: 200 }}>
      <h5>{M.GO_TO_PAGE}</h5>
      <select bind:value={settings.nextStep} on:change={onChange}>
        <option value="finish">{M.SKIP_TO_END}</option>
        {#each steps as step}
          <option value={step.id}>{step.name}</option>
        {/each}
      </select>
    </div>
  {/if}
  <div class="input-wrapper col20 f-left tags-ui-wrapper" bind:this={tagUi}>
    <div class="checkbox-wrapper col20 f-left">
      <input class="css-checkbox" type="checkbox" id="addTags" name="addTags" />
      <label for="addTags" class="css-label">{M.OPTION_ADD_TAGS}</label>
    </div>
    <ul class="tags-wrapper f-left col20 none-soft" />
  </div>
</div>
